import axios from "axios";

export const initInterceptors = (auth0Client, eventBus) => {
  axios.interceptors.request.use(async config => {
    const user = await auth0Client.getUser();
    const token = await auth0Client.getTokenSilently();
    //console.log(token);
    config.headers.Authorization = `Bearer ${token}`;
    eventBus.dispatchEvent(
      new CustomEvent("api-start", {
        detail: { config }
      })
    );
    return config;
  });

  axios.interceptors.response.use(
    response => {
      eventBus.dispatchEvent(
        new CustomEvent("api-end", {
          detail: { response }
        })
      );
      return response;
    },
    error => {
      eventBus.dispatchEvent(
        new CustomEvent("api-error", {
          detail: { error }
        })
      );
      eventBus.dispatchEvent(
        new CustomEvent("growl", {
          detail: {
            message: {
              clear: true,
              type:
                error.response.data && error.response.data.statusCode < 500
                  ? "warn"
                  : "error",
              summary: "Errore Applicativo",
              content:
                (error.response.data && error.response.data.message) ||
                "Si é verificato un errore. Si prega di riprovare."
            }
          }
        })
      );

      return Promise.reject(error);
    }
  );
};
